export default __webpack_public_path__ + "static/media/acceptance_marks.7729ca02.png";